
import { ProfileDetail } from "../../components";

const AccountPage = (props) => <ProfileDetail /> 
      
export default AccountPage;
